import { ReloadIcon } from '@/common/assets';
import { useNewTranslations } from '@/common/translations';
import { ErrorMessage } from '@/ui/components';

interface UnableToLoadErrorProps {
  onRetryClick: () => void;
}

export default function UnableToLoadError({ onRetryClick }: UnableToLoadErrorProps) {
  const translate = useNewTranslations();

  return (
    <ErrorMessage
      className="h-[351px] w-full px-4"
      title={translate('PreMatchStats.EmptyStateUnableToLoadTitle')}
      description={translate('PreMatchStats.EmptyStateUnableToLoadDescription')}
      buttonLabel={translate('PreMatchStats.EmptyStateUnableToLoadCta')}
      onButtonClick={onRetryClick}
      actionIcon={<ReloadIcon width={20} height={20} />}
    />
  );
}
